import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import App from './containers/App';
import Theme from './containers/Theme';
import history from './utils/history';
import store from './store';
import * as serviceWorker from './serviceWorker';

import './styles/common.css';

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <Theme>
        <App />
      </Theme>
    </Router>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
